export default "__VITE_ASSET__ClirDnVt__"